import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import urlJoin from 'url-join';
import { bindActionCreators } from 'redux';

import { withRentalPlanLabels, withPLPSelectPlanHandler } from 'ggApp/modules/rentalPlan/hocs';
import { getPrices } from 'ggApp/modules/rentalPlan/utils';
import {
    currentProductRentalPlans,
    selectedRentalPlanSelector,
    cheapestRentalPlanSelector,
} from 'ggApp/modules/rentalPlan/selectors';
import { keys as translationKeysSelector, translate } from 'ggApp/modules/translator/selectors';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import { CURRENCIES_ASSOCIATION } from 'ggApp/modules/store/constants';
import {
    productCoreAttributes as productCoreAttributesSelector,
    productPropertiesList as productPropertiesListSelector,
    currentProductById as currentProductByIdSelector,
    deliveryEstimates as deliveryEstimatesSelector,
} from 'ggApp/modules/product/selectors';
import { locationPathname, locationSearch } from 'ggApp/modules/router/selectors';
import { voucherCode as voucherCodeSelector } from 'ggApp/modules/referrals/selectors';
import { registerReferralPdpSharing as registerReferralPdpSharingEvent } from 'ggApp/modules/gaAnalytics/actions';
import { formatPriceByLanguage } from 'ggApp/utils/money';
import loadConfiguration from 'ggApp/utils/configuration/configuration';
import withProductVariantHandler from 'ggApp/shared/containers/product/detailedProductActions/productVariant';

import ProductDetails from './ProductDetails';

const {
    APP_CONFIG: { shopHost },
} = loadConfiguration();

const enhance = compose(
    connect(
        createStructuredSelector({
            activeStore: activeStoreSelector,
            rentalPlans: currentProductRentalPlans,
            selectedRentalPlan: selectedRentalPlanSelector,
            productCoreAttributes: productCoreAttributesSelector,
            productPropertiesList: productPropertiesListSelector,
            translationKeys: translationKeysSelector,
            pathname: locationPathname,
            search: locationSearch,
            cheapestRentalPlan: cheapestRentalPlanSelector,
            voucherCode: voucherCodeSelector,
            deliveryEstimate: deliveryEstimatesSelector,
        }),
        (dispatch) => ({
            registerReferralPdpSharing: bindActionCreators(
                registerReferralPdpSharingEvent,
                dispatch,
            ),
        }),
    ),
    withRentalPlanLabels(currentProductByIdSelector),
    withPLPSelectPlanHandler,
    withProductVariantHandler,
    withProps(({ activeStore, selectedRentalPlan }) => {
        const { price, oldPrice } = getPrices(activeStore, selectedRentalPlan);
        return {
            price,
            oldPrice,
        };
    }),
    withProps(
        ({
            activeStore,
            translationKeys,
            labels,
            pathname,
            search,
            cheapestRentalPlan,
            currentVariant,
            voucherCode,
            price,
        }) => {
            const productMessageForSharing = translate(
                translationKeys,
                activeStore.activeLanguage,
                'SHARING_PRODUCT_MESSAGE_PDP',
                {
                    name: labels ? labels.productName : (currentVariant || {}).name || '',
                    price: cheapestRentalPlan
                        ? formatPriceByLanguage(
                              cheapestRentalPlan.price,
                              CURRENCIES_ASSOCIATION[activeStore.default_currency],
                              activeStore.activeLanguage,
                          )
                        : price,
                    code: voucherCode,
                },
            );
            const productLinkForSharing = urlJoin(shopHost, pathname, search);
            return {
                dataForSharingProduct: {
                    message: productMessageForSharing,
                    link: productLinkForSharing,
                },
            };
        },
    ),
);

export default enhance(ProductDetails);
